import React from 'react'
import { useIdleTimer, IIdleTimerProps } from 'react-idle-timer'
import { AuthContainer } from 'containers'
import { ConfirmAlert } from 'components'
import { millisecondsToMinutes } from 'date-fns'

export const SESSION_EXPIRY_TIME = 1000 * 60 * 15 //In milliseconds
export const SESSION_ALERT_TIME = 1000 * 60 * 3 //In milliseconds

const ACTIVITY_EVENTS: IIdleTimerProps['events'] = [
  'keydown',
  'wheel',
  'DOMMouseScroll',
  'mousewheel',
  'mousedown',
  'touchstart',
  'touchmove',
  'MSPointerDown',
]

export const SessionHandler = () => {
  const { setSessionState, logOut } = AuthContainer.useContainer()
  const [sessionAlertOpen, setSessionAlertOpen] = React.useState(false)

  const { reset } = useIdleTimer({
    timeout: SESSION_EXPIRY_TIME - SESSION_ALERT_TIME,
    promptTimeout: SESSION_ALERT_TIME,
    onPrompt: () => handleAlertOpen(),
    onIdle: () => handleSessionLogout(),
    onAction: () => handleSessionUpdate(),
    debounce: 1000 * 3,
    events: ACTIVITY_EVENTS,
  })

  const handleSessionUpdate = () => {
    setSessionState({
      loginSession: '1',
    })
  }

  const handleSessionLogout = () => {
    setSessionAlertOpen(false)
    logOut()
  }

  const handleAlertOpen = () => {
    setSessionAlertOpen(true)
  }

  const handleAlertClose = () => {
    handleSessionUpdate()
    setSessionAlertOpen(false)
    reset()
  }

  return (
    <>
      {sessionAlertOpen && (
        <ConfirmAlert
          title="Alert"
          message={`Due to inactivity you will be logged out of the application in ${millisecondsToMinutes(
            SESSION_ALERT_TIME
          )} minutes.`}
          subMessage={'Do you want to stay logged in?'}
          confirmMessage={
            <span>
              Please click <strong>'Yes'</strong> to continue the session or <strong>'No'</strong> to log out.
            </span>
          }
          open={sessionAlertOpen}
          onClose={handleAlertClose}
          onConfirm={handleAlertClose}
          onReject={logOut}
        />
      )}
    </>
  )
}
